import React, { useState, useEffect } from "react";
import { useNavigate, useParams } from "react-router-dom";
import Swal from "sweetalert2";
import { useDispatch } from "react-redux";
import MainLayout from "../../../components/layout/MainLayout";
import Breadcrumbs from "../../../components/common/Breadcrumbs";
import HealthSafetyForm from "./HealthSafetyForm";

import { fetchHealthSafetyForm, updateHealthSafetyForm } from "../../../store/slices/healthSafetyFormSlice";

const EditHealthSafety = () => {
  const navigate = useNavigate();
  const { id } = useParams();
  const dispatch = useDispatch();

  const [formData, setFormData] = useState({
    caseId: null,
    patientId: null,
    relation: "",
    named: "",
    acceptTerms: false,
    primaryCaregiverSignature: "",
    witnessSignature1: "",
    witnessSignature2: ""
  });

  // Fetch form data on mount
  useEffect(() => {
    const fetchData = async () => {
      try {
        const data = await dispatch(fetchHealthSafetyForm(id)).unwrap();
        setFormData({
          caseId: data.case_id,
          patientId: data.patient_id,
          relation: data.relation,
          named: data.named,
          acceptTerms: data.accept_terms,
          primaryCaregiverSignature: data.primary_caregiver_signature,
          witnessSignature1: data.witness_signature1,
          witnessSignature2: data.witness_signature2
        });
      } catch (error) {
        Swal.fire("Error", "Failed to fetch Health & Safety form.", "error");
        navigate("/home-visit/health-safety");
      }
    };
    fetchData();
  }, [id, dispatch, navigate]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData(prev => ({ ...prev, [name]: type === "checkbox" ? checked : value }));
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    if (!formData.acceptTerms) {
      Swal.fire("Incomplete", "Please accept the terms.", "warning");
      return;
    }

    // Convert camelCase to snake_case for backend
    const payload = {
      case_id: formData.caseId,
      patient_id: formData.patientId,
      relation: formData.relation,
      named: formData.named,
      accept_terms: formData.acceptTerms,
      primary_caregiver_signature: formData.primaryCaregiverSignature,
      witness_signature1: formData.witnessSignature1,
      witness_signature2: formData.witnessSignature2
    };

    try {
      await dispatch(updateHealthSafetyForm({ id, data: payload })).unwrap();
      Swal.fire("Updated!", "Health & Safety form updated successfully.", "success");
      navigate("/home-visit/health-safety");
    } catch (error) {
      Swal.fire("Error!", "Failed to update form.", "error");
    }
  };

  return (
    <MainLayout>
      <div className="container-xxl flex-grow-1 container-p-y">
        <Breadcrumbs />
        <div className="card">
          <div className="card-body">
            <form onSubmit={handleSubmit}>
              <HealthSafetyForm formData={formData} handleChange={handleChange} />
              <div className="col-12 d-flex justify-content-end mt-3">
                <div className="col-md-2 d-flex justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-primary px-4"
                  >
                    <i className="ri-edit-2-line me-1"></i>
                    Update
                  </button>
                </div>
              </div>
            </form>
          </div>
        </div>
      </div>
    </MainLayout>
  );
};

export default EditHealthSafety;
